define('uikit/helper/freeze',['require','exports','module'],function(require, exports, module) {

  var Freeze = {

    freezeOption: function(view, optionName) {
      if (view && view._freezeProperty) {
        view._freezeProperty(optionName, 'options');
      }
      return view;
    },

    unfreezeOption: function(view, optionName) {
      if (view && view._unfreezeProperty) {
        view._unfreezeProperty(optionName, 'options');
      }
      return view;
    }

  };

  module.exports = Freeze;
});
